import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { Order } from '@leid/api-orders'

import { getOrderTotalPrice, getReductionDescriptionText, orderHasDiscounts } from 'utils/priceDescription'
import { removeDecimals } from 'utils/removeDecimals'
import { JSX } from 'react'

type Props = {
  order: Order | undefined
  isProlonging: boolean | undefined
  isReconciliation: boolean
}

const SummaryPriceInfo = ({ order, isProlonging, isReconciliation }: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'pageTitles'])

  return (
    <>
      <Box>
        <Text fontSize="xs">
          {t(isProlonging || isReconciliation ? 'common:additionalPayment' : 'common:totalPrice')}
        </Text>
        {order && (
          <Text fontSize="2xl">
            {removeDecimals(getOrderTotalPrice(order))} {t('nok')}
          </Text>
        )}
        {order && orderHasDiscounts(order) && order.originalPrice && (
          <Text fontSize="xl" textDecoration="line-through" color="green.a175" marginTop="-15px">
            {removeDecimals(order.originalPrice)} {t('nok')}
          </Text>
        )}
        <Text fontSize="xs">{t('including25Vat')}</Text>
        {order && orderHasDiscounts(order) && order.originalPrice && (
          <Text fontSize="xs">{getReductionDescriptionText(order, t)}</Text>
        )}

        {order && order.deposit !== undefined && (
          <Text fontSize="md">
            {t('common:deposit')}: {removeDecimals(order.deposit)} {t('nok')} ({t('included')})
          </Text>
        )}

        {order && order.depositUsed !== undefined && (
          <Text fontSize="md">
            {t('common:deposit')}: {removeDecimals(order.depositUsed)} {t('nok')} ({t('included')})
          </Text>
        )}
      </Box>
    </>
  )
}

export default SummaryPriceInfo
